<div class="consumption-footer">
  <label *ngIf="!hideDisclaimer" class="disclaimer">{{ 'module.meterReading.specifiedValuesAreNotRelevantDisclaimerLeftFooterText' | translate }}</label>
  <div class="excel-download-area">
    <button
      *ngIf="!!authService.permissions.SENSOR_OFFBOARDING"
      class="btn btn-outline-primary btn-offboard"
      (click)="offboardElement()"
      [hidden]="hideOffboarding"
    >
      <span class="fa fa-times-circle" aria-hidden="true"></span>{{ 'module.sensorData.offboarding.continue' | translate }}
    </button>
    <button class="btn btn-outline-primary btn-download" [disabled]="disableCsv" (click)="openWizard()" *ngIf="this.isDownloadWizardEnabled">
      <span class="fa fa-arrow-down" aria-hidden="true"></span>{{ 'module.meterReading.downloadConsumptionDataButtonText' | translate }}
    </button>
    <button class="btn btn-outline-primary btn-download" [disabled]="disableCsv" (click)="downloadCsv()" *ngIf="!this.isDownloadWizardEnabled">
      <span class="fa fa-arrow-down" aria-hidden="true"></span>{{ 'module.meterReading.downloadExcelButtonText' | translate }}
    </button>
  </div>
  <div *ngIf="isWizardVisible" class="overlay">
    <app-meter-download-wizard
      class="meter-download-wizard"
      [currentStep]="0"
      [isFromEnergyData]="false"
      [meter]="meter"
      [isSmd]="isSmd"
      [obisId]="obisId"
      [visibility]="isWizardVisible"
      (closeEvent)="closeWizard($event)"
    ></app-meter-download-wizard>
  </div>
</div>
